import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';
import { Employee } from '@app/shared/models/employee';
import { Language, SelectedLanguage, TrainingLanguages } from '@app/shared/models/language';
import { EmployeeService } from '@app/shared/services/employee.service';
import { LanguageService } from '@app/shared/services/language.service';
import { SharedModule } from '@app/shared/shared.module';

@Component({
	selector: 'kpa-appbar',
	templateUrl: './kpa-appbar.component.html',
	styleUrl: './kpa-appbar.component.scss',
})
export class KpaAppbarComponent implements OnInit {
	@Output() toggleSidenav = new EventEmitter();
	@Output() languageChange = new EventEmitter();
	@Input() setLanguage: SelectedLanguage;
	@Input() isSideNavOpen: boolean;
	@Input() isMobile: boolean;
	@Input() isZenith: boolean;
	employee: Employee;
	language: Language;
	selectedLanguage: SelectedLanguage;
	trainingLanguages: TrainingLanguages[];
	hasEmployeeStartedTrainings: boolean = false;
	data = [{ text: 'Log Out' }];

	constructor(
		private readonly languageService: LanguageService,
		private readonly employeeService: EmployeeService,
		private readonly authService: AuthService
	) {}

	onToggleSidenav() {
		this.toggleSidenav.emit();
	}

	ngOnInit() {
		this.getEmployee();
		this.getlanguage();
	}

	getEmployee() {
		this.employeeService.getEmployee().subscribe((result: Employee) => {
			this.employee = result;
			this.isZenith = this.employee && this.employee.isZenith;
		});
	}

	getlanguage() {
		this.languageService.getLanguage().subscribe((result: Language) => {
			this.language = result;
			this.trainingLanguages = this.language.trainingLanguages;
			this.selectedLanguage = this.language.selectedLanguage;
		});
	}

	onLanguageChange() {
		this.languageChange.emit(true);
	}

	onDropdownItemClick(event: any) {
		if (event.text === 'Log Out') {
			// Perform logout action here, e.g., call AuthService logout method
			this.authService.logout(); // Ensure you have AuthService injected
		}
	}
	
	logout() {
		this.authService.logout();
	}
}
